module.exports = __webpack_public_path__ + "static/media/facebookIcon.43540625.svg";